module.exports = __webpack_public_path__ + "static/media/xeon-logo.f7502795.png";